<div class="row">
  <div class="flex justify-between items-center mb-2">
    <h4 class="m-0!">مجله افرا</h4>
    <a target="_blank" href="https://afraway.org/blog/">
      <p-button outlined label="{{ 'homePage.labels.seeAll' | translate }}">
      </p-button>
    </a>
  </div>

  <div class="col-12 p-0 d-md-none">
    <swiper-container [navigation]="true" [loop]="true">
      <swiper-slide *ngFor="let item of newsItems">
        <div class="m-5">
          <ng-container
            *ngTemplateOutlet="magazineCard; context: { $implicit: item }"
          ></ng-container>
        </div>
      </swiper-slide>
    </swiper-container>
  </div>

  <div class="col-12 d-none d-md-block">
    <div class="row row-cols-lg-4 row-cols-xl-5 row-cols-2">
      <div class="col p-2" *ngFor="let item of newsItems">
        <ng-container
          *ngTemplateOutlet="magazineCard; context: { $implicit: item }"
        ></ng-container>
      </div>
    </div>
  </div>

  <ng-template #magazineCard let-item>
    <div class="bg-white shadow p-3 rounded d-flex flex-column h-120">
      <img
        [src]="item.image"
        class="card-img-top rounded object-fit-cover h-72"
        alt="..."
      />
      <div class="card-body d-flex flex-column grow h-0">
        <div class="mt-2 w-100 text-elipsis d-inline-block">
          <a
            [href]="item.link"
            class="text-decoration-none text-reset"
            target="_blank"
          >
            <p class="threeline-ellipsis">{{ item.title }}</p>
          </a>
        </div>
        <div class="mt-auto">
          <ng-icon name="lucideCalendar" class="me-2 text-secondary"></ng-icon>
          <span class="text-secondary">{{ item.publish_time }}</span>
        </div>
      </div>
    </div>
  </ng-template>
</div>
